import { mutationTypes } from '@/core/constants'
import _ from 'lodash'

export default {
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_JUSTIFICATIVA](state) {
		state.justificativa = ''
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_JUSTIFICATIVA](state, justificativa) {
		state.justificativa = justificativa
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_DATASOURCE](state, data) {
		if (data) state.datasource = getItensClassificacaoAnterior(data)
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_TOTAL_ELEMENTS](state, totalElements) {
		if (totalElements) state.totalElements = totalElements
		else state.totalElements = 0
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_TOTAL_PAGES](state, totalPages) {
		if (totalPages) state.totalPages = totalPages
		else state.totalPages = 0
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_DATASOURCE](state) {
		state.datasource = []
		state.totalElements = 0
		state.totalPages = 0
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_FAIXA_MIN_CLASSIFICACAO](state, min) {
		state.faixaMinClassificacao = min
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_FAIXA_MAX_CLASSIFICACAO](state, max) {
		state.faixaMaxClassificacao = max
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.SET_ALTERACOES_CLASSIFICACAO](state, dados) {
		state.alterarClassificacao.idItemAta = dados.idItemAta
		state.alterarClassificacao.justificativa = state.justificativa
		state.alterarClassificacao.alteracoes = getAlteracoesItem(dados.alteracoes)
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.ALTERAR.RESET_ALTERACOES_CLASSIFICACAO](state) {
		state.alterarClassificacao.idItemAta = null
		state.alterarClassificacao.justificativa = ''
		state.alterarClassificacao.alteracoes = []
	},
}

function getItensClassificacaoAnterior(itens) {
	return itens.map((item) => {
		item._classificacao = _.cloneDeep(item.classificacao)
		item.classificacaoAnterior = _.cloneDeep(item.classificacao)
		return item
	})
}
function getAlteracoesItem(alteracoes) {
	return alteracoes.map((fornecItem) => {
		return {
			idFornecAta: fornecItem.id,
			classificacaoAnterior: fornecItem.classificacaoAnterior,
			classificacaoNova: parseInt(fornecItem.classificacao),
		}
	})
}
